export enum ModalType {
    Shipping,
    Billing,
    ARN,
    Questionnare,
    SayanNotAvailable,
}
